import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from './components/ui/toaster.js';
import './index.css';
import { clearCsrfToken } from './lib/api/csrf.js';
import { setUnauthorizedHandler } from './lib/api/unauthorized.js';
import { queryKeys } from './lib/query/keys.js';
import { queryClient, router } from './router.js';

/**
 * Répond à `notifyUnauthorized` (`lib/api/unauthorized.ts`) : une 401, ou une
 * 403 déclenchée par une mutation (donc un rejet CSRF, `04` §6), vide le
 * jeton CSRF, invalide la session en cache et renvoie vers `/connexion` sans
 * recharger la page.
 */
setUnauthorizedHandler(() => {
  clearCsrfToken();
  queryClient.removeQueries({ queryKey: queryKeys.auth.me() });
  void router.navigate({ to: '/connexion' });
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Élément racine #root introuvable dans index.html');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
    </QueryClientProvider>
  </StrictMode>,
);
